import TextChartTitle from '@components/text/TextChartTitle'
import { IResponseGetProjectDataForDashboardRowData } from '@interfaces/api/IDashboard'
import Money from '@utils/Money'
import _ from 'lodash'
import React from 'react'
import Chart from 'react-google-charts'
import ChartFlexSection from './ChartFlexSection'
import { PieChartOptions } from './setting'

interface IProjectBudgetByProjectTypePieChart {
  title: string
  data: IResponseGetProjectDataForDashboardRowData[]
}

const ProjectBudgetByProjectTypePieChart = ({
  title,
  data,
}: IProjectBudgetByProjectTypePieChart) => {
  const groupBy: keyof IResponseGetProjectDataForDashboardRowData = 'project_type_name'
  const prepareData = _(data)
    .groupBy(groupBy)
    .map((values, key) => {
      return {
        project_type_name: key,
        total_project_amount: values.length,
        total_project_budget: _.sumBy(values, (p) => Number(p.project_budget)),
      }
    })
    .value()

  const prepareDatawithAnnotation = prepareData.map((p) => [
    `${p.project_type_name} (${p.total_project_amount} โครงการ)
        มูลค่า ${Money(p.total_project_budget)}`,
    p.total_project_budget,
  ])

  const ProjectBudgetByProjectTypePieChartData = [
    ['ประเภทกิจกรรมบริการวิชาการ', 'งบประมาณ'],
    ...prepareDatawithAnnotation,
  ]

  const options = PieChartOptions('งบประมาณ', 'ประเภทกิจกรรมบริการวิชาการ')

  return (
    <ChartFlexSection className="pagebreak">
      <TextChartTitle>{title}</TextChartTitle>
      <Chart
        width={'100%'}
        height={'500px'}
        chartType="PieChart"
        loader={<div>Loading Chart</div>}
        data={ProjectBudgetByProjectTypePieChartData}
        options={options}
      />
    </ChartFlexSection>
  )
}

export default ProjectBudgetByProjectTypePieChart
